export default {
  '11': require('../../assets/FuncTypeIcons/temperature.svg'),
  '12': require('../../assets/FuncTypeIcons/lux.svg'),
  '13': require('../../assets/FuncTypeIcons/door.svg'),
  '14': require('../../assets/FuncTypeIcons/pir.svg'),
  '15': require('../../assets/FuncTypeIcons/humidity.svg'),
  '16': require('../../assets/FuncTypeIcons/gpio.svg'),
  '17': require('../../assets/FuncTypeIcons/smoke.svg'),
  '18': require('../../assets/FuncTypeIcons/co.svg'),
  '19': require('../../assets/FuncTypeIcons/co2.svg'),
  '20': require('../../assets/FuncTypeIcons/flood.svg'),
  '21': require('../../assets/FuncTypeIcons/glass.svg'),
  '22': require('../../assets/FuncTypeIcons/meter.svg'),
  '23': require('../../assets/FuncTypeIcons/switch.svg'),
  '24': require('../../assets/FuncTypeIcons/dimmer.svg'),
  '25': require('../../assets/FuncTypeIcons/siren.svg'),
  '26': require('../../assets/FuncTypeIcons/curtain.svg'),
  '27': require('../../assets/FuncTypeIcons/remote.svg'),
  '28': require('../../assets/FuncTypeIcons/button.svg'),
  '29': require('../../assets/FuncTypeIcons/meter.svg'),
  '30': require('../../assets/FuncTypeIcons/dimmer.svg'),
  '31': require('../../assets/FuncTypeIcons/doorlock.svg'),
  '32': require('../../assets/FuncTypeIcons/thermostat.svg'),
  '33': require('../../assets/FuncTypeIcons/thermostat.svg'),
  '34': require('../../assets/FuncTypeIcons/thermostat.svg'),
  '35': require('../../assets/FuncTypeIcons/control.svg'),
  '36': require('../../assets/FuncTypeIcons/valveswitch.svg'),
  '37': require('../../assets/FuncTypeIcons/air.svg'),
  '40': require('../../assets/FuncTypeIcons/uv.svg'),
  '41': require('../../assets/FuncTypeIcons/dimmer.svg'),
  '42': require('../../assets/FuncTypeIcons/sunrise.svg'),
  '43': require('../../assets/FuncTypeIcons/sunset.svg'),
  '47': require('../../assets/FuncTypeIcons/camera.svg'),
  '56372': require('../../assets/FuncTypeIcons/alarm.svg'),
  '56373': require('../../assets/FuncTypeIcons/scene.svg'),
  '56374': require('../../assets/FuncTypeIcons/alarm.svg'),
  'unknown': require('../../assets/FuncTypeIcons/unknown.svg')
}



// WEBPACK FOOTER //
// ./src/components/utils/FuncTypeIcons.js